import { NO_BIDI } from "./contextAttributes";

// O caminho de uma pagina como se le (D8 do plano das paginas do RPAA-286): o backend guarda-o codificado em
// percentagem e em minusculas, o hexadecimal incluido (o `normalize_segment` baixa o caminho inteiro:
// `/promo%c3%a7%c3%b5es`), e aqui descodifica-se. Um `%` partido nao se descodifica e o caminho fica como veio.
// Os caracteres de controlo bidirecionais saem, como no rotulo do `parsePageUrl`. No cartao e texto e nunca uma
// ligacao: um `:id` nao e uma pagina. A marca de pagina do visualizador (utils/conversationPages.js) usa-o tambem.
export const pageLabel = (path) => {
  let decoded;
  try {
    decoded = decodeURIComponent(path);
  } catch (error) {
    decoded = path;
  }
  return decoded.replace(NO_BIDI, "");
};

// As linhas do cartao das paginas, na forma do `rankedRows`: as paginas pela ordem do backend e, a cinzento no
// fim, as outras paginas (so onde comecaram) e as conversas sem pagina. `which` e "start" ou "message". As
// chaves sao os caminhos como vieram, que comecam sempre por `/` e por isso nunca colidem com as duas reservadas.
export const pageRows = (pages, which, translate) => {
  const rows = pages[which].pages.map((page) => ({ key: page.path, value: page.conversations, label: pageLabel(page.path), muted: false }));
  if (which === "start" && pages.start.others > 0) {
    rows.push({ key: "others", value: pages.start.others, label: translate("analyticsPagesOthers"), muted: true });
  }
  if (pages.without_page > 0) {
    rows.push({ key: "without_page", value: pages.without_page, label: translate("analyticsPagesWithout"), muted: true });
  }
  return rows;
};
